import {
  Autocomplete,
  AutocompleteProps,
  CircularProgress,
  TextField,
} from "@mui/material";
import { useField } from "formik";
import { useRequest } from "hooks";
import _ from "lodash";
import { IGetAllProductLotsRequest } from "model";
import { useCallback, useEffect, useState } from "react";
import { ProductionPlanApiService } from "services";
import { I18nTranslator, translations } from "utils/i18n";

interface IProductLotSelectProps
  extends Pick<
    AutocompleteProps<string, undefined, undefined, undefined>,
    "defaultValue" | "disabled"
  > {
  productId?: string;
  isLocal?: boolean;
  required?: boolean;
}
export const ProductLotSelect = ({
  productId,
  defaultValue,
  disabled,
  isLocal,
  required = true,
}: IProductLotSelectProps) => {
  const [_value, setValue] = useState<string | undefined | null>(defaultValue);
  // const [isProductLotSelectOpen, setIsProductLotSelectOpen] =
  //   useState<boolean>(false);
  const [getAllProductLotsRequest, setGetAllProductsLotRequest] =
    useState<IGetAllProductLotsRequest>({
      pageNumber: 1,
      pageSize: 100,
    });
  const { data: productLots, loading: isLoadingProductLot } = useRequest<
    IGetAllProductLotsRequest,
    string[]
  >(getAllProductLotsRequest, ProductionPlanApiService.getAllProductLots);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helper] = useField("productLot");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setGetAllProductsLotsSearchText = useCallback<
    (searchText: string) => void
  >(
    _.debounce((searchText: string) => {
      setGetAllProductsLotRequest((prev) => ({
        ...prev,
        searchText: searchText,
      }));
    }, 500),
    []
  );

  useEffect(() => {
    setGetAllProductsLotRequest((prev) => ({ ...prev, productId: productId }));
  }, [productId]);

  useEffect(() => {
    field.value !== _value && setValue(field.value);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value]);

  return (
    <Autocomplete<string, undefined, undefined, boolean>
      freeSolo={!isLocal}
      id="get-all-product-lot"
      // open={isProductLotSelectOpen}
      // onOpen={() => {
      //   setIsProductLotSelectOpen(true);
      // }}
      // onClose={() => {
      //   setIsProductLotSelectOpen(false);
      // }}
      isOptionEqualToValue={(option, value) => option === value}
      options={productLots || []}
      filterOptions={(x) => x}
      loading={isLoadingProductLot}
      onChange={(_, value) => {
        helper.setValue(value || "");
        setValue(value || "");
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={I18nTranslator(translations.report.productLot)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoadingProductLot ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          required={required}
          onChange={(e) => {
            if (!isLocal) {
              helper.setValue(e.target.value || "");
              setValue(e.target.value || "");
            }
          }}
          error={meta.touched && !_.isEmpty(meta.error)}
          helperText={meta.touched && meta.error && I18nTranslator(meta.error)}
        />
      )}
      onInputChange={(__, newInputValue) => {
        setGetAllProductsLotsSearchText(newInputValue);
      }}
      defaultValue={defaultValue}
      value={_value}
      disabled={disabled}
    />
  );
};
